import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Icon, IconButton, Tooltip, Typography } from '@emburse/embark-core';
import { CopyIcon } from '@emburse/embark-icons';
function CopyableMessage({ message }) {
    const [isHovered, setIsHovered] = useState(false);
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        }, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: [_jsx(Tooltip, { placement: "top-start", title: message, children: _jsx(Typography, { noWrap: true, children: message }) }), isHovered && (_jsx(IconButton, { sx: { marginLeft: 'auto' }, size: "small", "aria-label": "copy", onClick: (event) => {
                    event.stopPropagation();
                    navigator.clipboard.writeText(message);
                }, children: _jsx(Icon, { iconUrl: CopyIcon }) }))] }));
}
export default CopyableMessage;
